module.exports = __webpack_public_path__ + "img/framer.bbc721b4.svg";